export default "__VITE_ASSET__88871805__"